import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities, gtmPush } from '../../../helpers'
import { link, linkWrapper } from '../../cms/blocks/utils.gen'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type MenuLocation = 'main' | 'footer' | 'copyright' | "top"

type Props = {
  location: MenuLocation
  hasActiveState: boolean
  before?: JSX.Element
  after?: JSX.Element
  cssClass?: string
  showDescription?: boolean
  hoveredItem?: WordPress.MenuItem
  onHoverItem?: (menuItemId: WordPress.MenuItem) => void
  onUnhoverItem?: () => void
}


type State = withDataState<WordPress.MenuLocationResponse> & { hover: boolean }

export default class MainNavItems extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading',
      hover: false,
    }

    // this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this)
    // this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this)
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => this.setState(s => ({ ...s, kind: 'loaded', data: Option(response.data) })))
      .catch(() => this.setState({ kind: 'error' }))
  }

  // handleOnMouseEnter(item: WordPress.MenuItem) {
  //   this.setState(s => ({...s, hover: true }))
  // }

  // handleOnMouseLeave() {
  //   this.props.onUnhoverItem ? this.props.onUnhoverItem() : null
  //   this.setState(s => ({ ...s, hover: false }))
  // }

  render() {
    let classes = [
      'nav__list',
      this.props.cssClass ? `nav__list--${this.props.cssClass}` : `nav__list--${this.props.location}`,
      this.props.hoveredItem ? 'nav__list--hover' : ''
    ]

    if (this.state.kind != 'loaded') return <></>
    if (this.state.data.kind == 'none') return <></>

    if (this.props.location == 'top') {
      return <>
        {
          this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) =>
            <li key={`${this.props.location}-${index}`} className="nav__item nav__item--top">
              {link(linkWrapper({ title: menuItem.title, url: menuItem.url }), { classname: "nav__link nav__link--top typo--xs" }, menuItem.title)}
            </li>)
        }
      </>
    }
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <>
          <ul className={classes.join(' ')}>
            {this.props.before}
            {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
              <li
                key={`${this.props.location}-${index}`}
                onMouseEnter={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null}
                onFocus={_ => this.props.onHoverItem ? this.props.onHoverItem(menuItem) : null}
                // onBlur={this.handleOnMouseLeave}
                // onMouseLeave={this.handleOnMouseLeave}
                className={`nav__item nav__item--${this.props.location} ${menuItem.classes} ${menuItem.child_items && menuItem.child_items.length > 0 ? 'nav__item--has-children' : ''
                  }`}
              >
                {menuItem.child_items && menuItem.child_items.length > 0 ? (
                  <>
                    <a className={`nav__link nav__link--${this.props.location}`} style={{cursor: "default"}} onClick={(e) => {
                      const anchorElement : HTMLElement = e.target as HTMLElement
                      const button = anchorElement.parentElement.getElementsByTagName('button')[0]
                      // disables onclick function on mobile
                      if(!button || window.getComputedStyle(button).display == "none" ) return
                      if (button.classList.contains('nav__button--toggled')) {
                        button.classList.remove('nav__button--toggled')
                      } else {
                        button.classList.add('nav__button--toggled')
                      }
                      if (this.props.location == 'main') {
                        gtmPush({
                          event: 'menu',
                          menu_type: 'main',
                          click_text: menuItem.title
                        })
                      }
                    }}>
                      {decodeHTMLEntities(menuItem.title)}
                    </a>
                  </>
                ) : (
                  <>
                    {this.navItem(menuItem, () => {
                      if (this.props.location == 'main') {
                        gtmPush({
                          event: 'menu',
                          menu_type: 'main',
                          click_text: menuItem.title
                        })
                      }
                    })}
                  </>
                )}
                
                {menuItem.child_items && menuItem.child_items.length > 0 ? (<>
                  <button className="nav__button"
                    onClick={(e) => {
                      if (e.currentTarget.classList.contains('nav__button--toggled')) {
                        e.currentTarget.classList.remove('nav__button--toggled')
                      } else {
                        e.currentTarget.classList.add('nav__button--toggled')
                      }
                    }}>
                    <svg
                      className="nav__icon"
                      width="12px"
                      height="6px"
                      aria-hidden="true"
                    >
                      <use xlinkHref="#chevron--down" />
                    </svg>
                  </button>
                  <div className="nav nav--submenu submenu--mobile">
                    <ul className="submenu__list">
                      {menuItem.child_items.map((menuChild: WordPress.MenuItem) => (
                        <li
                          key={`${this.props.location}-sub-${menuChild.url}`}
                          className="submenu__item">{this.navItem(menuChild, () => {
                            gtmPush({
                              event: 'menu',
                              menu_type: 'sub',
                              click_text: menuChild.title
                            })
                          })}</li>
                      ))}
                    </ul>
                  </div>
                </>) : (
                  ''
                )}
              </li>
            ))}
            {this.props.after}
          </ul>
        </>
      )
    )
  }

  navItem(menuItem: WordPress.MenuItem, onClick?: () => void) {
 return link(linkWrapper({ title: menuItem.title, url: menuItem.url }), { classname: `nav__link nav__link--${this.props.location}` }, <>
      {decodeHTMLEntities(menuItem.title)}
      {this.props.showDescription && <>
        <div className="nav__description">{menuItem.description}</div>
        {menuItem.button_label}
      </>}
    </>, onClick)
  }
}
